import { render, staticRenderFns } from "./SysSwitch.vue?vue&type=template&id=1d85ca46&scoped=true&"
import script from "./SysSwitch.vue?vue&type=script&lang=js&"
export * from "./SysSwitch.vue?vue&type=script&lang=js&"
import style0 from "../../../../src/css/setting/cell.css?vue&type=style&index=0&id=1d85ca46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d85ca46",
  null
  
)

export default component.exports